import { ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';
import { IoIosArrowBack } from 'react-icons/io';
import { Link } from 'react-router-dom';

type TextLinkProps = {
  url: string;
  external: boolean;
  arrow?: boolean;
  variant?: 'primary' | 'secondary';
} & ComponentProps<'a'>;

const TextLink = ({
  url,
  external,
  arrow = false,
  variant = 'primary',

  ...props
}: TextLinkProps) => {
  if (external)
    <a
      className={twMerge(
        'flex items-center gap-1 font-normal',
        variant === 'primary'
          ? 'text-ph-gray-silver hover:text-ph-gray-white'
          : 'text-ph-primary-violet hover:text-ph-secondary-portage',
      )}
      {...props}
    >
      {arrow && <IoIosArrowBack />}
      <span className="text-sm underline underline-offset-4">{props.children}</span>
    </a>;

  return (
    <Link
      className={twMerge(
        'flex items-center gap-1 font-normal',
        variant === 'primary'
          ? 'text-ph-gray-silver hover:text-ph-gray-white'
          : 'text-ph-primary-violet hover:text-ph-secondary-portage',
      )}
      to={url}
    >
      {arrow && <IoIosArrowBack />}
      <span className="text-sm underline underline-offset-4">{props.children}</span>
    </Link>
  );
};

export default TextLink;
